<template>
    <div class="text-a-brown-502314 mb-10 pt-4">
        <div class="label text-14 lg:text-base font-bold mb-6">
            {{ label }}
        </div>
        <div class="controls grid grid-cols-2 gap-4">
            <template v-for="(item, idx) of items" :key="`rad-item-${idx}`">
                <div class="cursor-pointer flex items-center" @click="onClickItem(item)">
                    <div class="flex-none">
                        <img v-show="!isSelected(item)" src="@/assets/radio/radio-inactive.svg" />
                        <img v-show="isSelected(item)" src="@/assets/radio/radio-active.svg" />
                    </div>
                    <div class="flex-auto text-14 lg:text-base ml-2">
                        <span class="flex-none" :class="[isSelected(item) ? 'text-a-red-d62300' : '']">{{ item[textKey]
                        }}</span>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
// import { ref } from 'vue'

import { onMounted } from 'vue'

export default {
    name: 'RadioGroup',
    props: {
        modelValue: {
            type: [Number, String, Object]
        },
        label: {
            type: String,
            default: ""
        },
        items: {
            type: Array,
            default: () => []
        },
        isRequired: {
            type: Boolean,
            default: true
        },
        valueKey: {
            type: String,
            default: 'value'
        },
        textKey: {
            type: String,
            default: "text"
        }
    },
    components: {},
    mixins: [],
    emits: ["update:modelValue", "onReady"],
    data: function () { return {} },
    setup: function (props, context) {

        const isSelected = function (item) {
            if (props.modelValue != null) {
                if (item[props.valueKey] == props.modelValue[props.valueKey])
                    return true
            }

            return false
        }

        const onClickItem = function (item) {
            context.emit("update:modelValue", item)
        }

        onMounted(() => {
            if (props.isRequired && props.modelValue == null) {
                let first = props.items?.[0] ?? null
                if (first != null) {
                    context.emit("update:modelValue", first)
                }
            }
            context.emit("onReady")
        })

        return {
            isSelected,
            onClickItem
        }
    },
    mounted: function () { },
    methods: {}
}
</script>
